<template>
    <div class="v-custom-enrich-contacts col col-12 pa-0 input-form">
        <v-col>
            <v-row justify="space-between" class="align-end">
                <span class="label"><b>{{ $t("data_enrichment") }}</b></span>

                <v-chip outlined label color="green" class="pa-6">
                    <v-icon class="mr-4">$sackdollar_d</v-icon>
                    <span>
                        <b>
                            {{ $t("ordering") }} : {{ (model[fieldName] * field.data.unit_price).toFixed(2).replace('.', ',') }}€
                        </b>
                    </span></span>
                </v-chip>
            </v-row>
        </v-col>

        <v-row :class="index === 0 ? 'mt-4' : 'mt-6'" v-for="(list, index) in field.data.lists" :key="index">
            <v-col class="py-0">
                <v-card color="lightgrey" class="py-3 px-6 no-shadow">
                    <v-col class="d-flex">
                        <v-row justify="space-between" class="align-center">
                            <div>{{ list.name }}</div>
                            <div><b>{{ list.contact_count }} {{ $t("contacts").toLowerCase() }}</b></div>
                        </v-row>
                    </v-col>
                </v-card>
            </v-col>
        </v-row>

        <v-row class="mt-6" justify="space-between" v-if="field.slider">
            <v-col class="pt-0 text-center">
                <v-card color="lightgrey" class="pa-3 no-shadow h-100 d-flex flex-column justify-center">
                    <div><b>{{ $t("without_enrichment") }}</b></div>
                    <div class="text-h5 my-1"><b>{{ field.data.reachable }}</b></div>
                    <div>
                        {{ $t("reachable_contacts") }}
                        <infoTooltip :tooltip="{ title: 'details', description: getTooltipDescription(), description_no_trad: true }" />
                    </div>
                </v-card>
            </v-col>
            <!-- <v-col class="pt-0 text-center">
                <v-card outlined class="pa-3 no-shadow h-100 d-flex flex-column justify-center">
                    <div class="text-h5 my-1 green--text"><b>+ {{ model[fieldName] }}</b></div>
                    <div><b>{{ $t("contacts") }}</b></div>
                    <div class="mt-1">
                        <v-slider color="secondary" track-color="lightgrey" hide-details v-model="model[fieldName]" :max="field.data.enrichable" min="1"></v-slider>
                    </div>
                </v-card>
            </v-col> -->
            <v-col class="pt-0 text-center">
                <v-card color="#EEF5EA" class="pa-3 no-shadow h-100 d-flex flex-column justify-center">
                    <div><b>{{ $t("with_enrichment") }}</b></div>
                    <div class="text-h5 my-1 green--text"><b>{{ field.data.reachable + model[fieldName] }}</b></div>
                    <div class="green--text"><b>{{ $t("reachable_contacts") }}</b></div>
                </v-card>
            </v-col>
        </v-row>

        <v-row class="mt-6" justify="space-between" v-else>
            <v-col class="pt-0 text-center">
                <v-card color="#EEF5EA" class="pa-3 no-shadow h-100 d-flex flex-column justify-center">
                    <div><b>{{ $t("to_enrich") }}</b></div>
                    <div class="text-h5 my-1 green--text"><b>{{ model[fieldName] }}</b></div>
                    <div class="green--text mb-2"><b>{{ $t("contacts") }}</b></div>
                    <div v-for="(enrichedField, index) in model.enrichableFields" :key="index">
                        <div v-if="enrichedField > 0">{{ $t(index) }} : {{ enrichedField }}</div>
                    </div>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import infoTooltip from '@/components/infoTooltip';

export default {
    components: { infoTooltip },
    props: ["model", "fieldName", "field"],
    data() {
        return {

        };
    },
    created() {
    },
    methods: {
        getTooltipDescription() {
            let description = this.field.data.details.total + ' ' + this.$t("enrich_total_contacts") + '<br>';
            description += '- ' + this.field.data.details.duplicates + ' ' + this.$t("enrich_duplicates") + '<br>';
            description += '- ' + this.field.data.details.blacklisted + ' ' + this.$t("enrich_blacklisted") + '<br>';
            description += '- ' + this.field.data.details.empty + ' ' + this.$t("enrich_empty_" + this.field.data.canal) + '<br>';

            return description;
        },
    },
};
</script>

<style lang="scss">
    .v-custom-enrich-contacts {
        span {
            font-size: medium !important;
        }

        .v-input__slot {
            background-color: transparent !important;
        }
    }
</style>